/* eslint-disable camelcase */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import { Link } from 'react-router';
import { loadAddEventBase, setHeader, dataGroupResetSelected, resetEventConflictChecks, setFlashMessage, removeFlashMessage } from 'actions';
import moment from 'moment';
import has from 'lodash/has';

import Loading from 'components/common/Loading';
import EventEdit from 'components/calendar/EventEdit';

class EventAddPage extends PureComponent {
  state = {}

  componentWillMount() {
    this.props.setHeader('Add Event', false, '', <Link to={`/calendar/`}>Cancel</Link>);
    this.props.loadAddEventBase({ onError: (error) => {
      if (has(error, 'error_msgs[0]')) {
        this.props.setFlashMessage(error.error_msgs.join('. '), 'error');
        setTimeout(() => this.props.removeFlashMessage(), 5000);
        this.props.push('/calendar');
      }
    } });
    this.props.dataGroupResetSelected('locations', 'local_facility');
    this.props.dataGroupResetSelected('groups', 'school_group_school_restricted');
    this.props.dataGroupResetSelected('equipment', 'school_equipment');
    this.props.resetEventConflictChecks();
  }

  componentWillReceiveProps(nextProps) {
    if (has(nextProps, 'addEventBase.config')) {
      if (nextProps.addEventBase.config.require_department === '1') {
        this.props.dataGroupResetSelected('departments', 'department');
      }
      if (nextProps.addEventBase.config.require_activity === '1') {
        this.props.dataGroupResetSelected('activities', 'activity');
      }
      if (nextProps.addEventBase.config.require_event_type === '1') {
        this.props.dataGroupResetSelected('event_types', 'event_type');
      }
    }
  }

  render() {
    const { addEventBase } = this.props;

    if (!addEventBase || !addEventBase.config) {
      return (
        <Loading withWrapper />
      );
    }

    const event = {
      ...addEventBase,
      isLoading: false,
      labels: {
        start_moment: moment(),
      },
    };

    return (
      <EventEdit event={event} />
    );
  }
}

function mapStateToProps(state) {
  const addEventBase = has(state, 'addEventBase.config') ? state.addEventBase : {};

  return {
    addEventBase,
  };
}

export default connect(mapStateToProps, {
  loadAddEventBase,
  setHeader,
  dataGroupResetSelected,
  resetEventConflictChecks,
  setFlashMessage,
  removeFlashMessage,
  push,
})(EventAddPage);



// WEBPACK FOOTER //
// ./src/app/containers/EventAddPage.js